module.exports = __webpack_public_path__ + "img/camp03_close.8dc5f83e.png";